import React from 'react'
import VipLayout from '../../../components/vip/VipLayout'

const InternetLicensesPage: React.FC = () => {
  return (
    <VipLayout>
      <main>
        <section className="hero">
          <div className="container">
            <span className="kicker">Internet Business Licenses</span>
            <h1>网站备案与互联网商业资质咨询</h1>
            <p>围绕网站上线、经营性互联网信息服务、平台交易与在线数据处理等场景，提供 ICP 备案、ICP 经营许可证与 EDI 许可证的路径判断与申报辅导。</p>
            <div className="anchor-nav">
              <a href="#icp-filing">ICP备案</a>
              <a href="#icp-license">ICP 经营许可证</a>
              <a href="#edi-license">EDI 许可证</a>
            </div>
          </div>
        </section>
        <section className="section" id="icp-filing">
          <div className="container two-col">
            <div>
              <h2 className="section-title">ICP备案咨询</h2>
              <p className="section-desc">适用于网站、小程序、App 等互联网信息服务上线前的基础备案要求判断。</p>
            </div>
            <div className="card content-card">
              <ul className="list">
                <li>网站备案适用性判断</li>
                <li>域名、服务器、主体材料清单</li>
                <li>备案流程辅导与常见问题说明</li>
                <li>与 ICP 经营许可证的边界区分</li>
              </ul>
            </div>
          </div>
        </section>
        <section className="section" id="icp-license">
          <div className="container two-col">
            <div className="card content-card">
              <ul className="list">
                <li>经营性互联网信息服务场景判断</li>
                <li>收费模式与业务形态梳理</li>
                <li>申请条件核查与材料准备</li>
                <li>网站 / App 展示内容整改建议</li>
              </ul>
            </div>
            <div>
              <h2 className="section-title">ICP 经营许可证咨询</h2>
              <p className="section-desc">适用于会员收费、SaaS 收费、点数收费、信息服务收费等经营性互联网信息服务场景。</p>
            </div>
          </div>
        </section>
        <section className="section" id="edi-license">
          <div className="container">
            <h2 className="section-title">EDI 许可证咨询</h2>
            <div className="grid cols-3" style={{marginTop: '24px'}}>
              <div className="card content-card">
                <h3>适用场景判断</h3>
                <p className="lead" style={{fontSize: '15px'}}>围绕交易平台、第三方电商平台及在线数据处理场景判断是否适用。</p>
              </div>
              <div className="card content-card">
                <h3>业务模式拆解</h3>
                <p className="lead" style={{fontSize: '15px'}}>帮助客户区分 ICP 与 EDI 的边界，避免路径判断错误。</p>
              </div>
              <div className="card content-card">
                <h3>申报辅导</h3>
                <p className="lead" style={{fontSize: '15px'}}>整理基础材料、系统填报与补正问询支持。</p>
              </div>
            </div>
          </div>
        </section>
      </main>
    </VipLayout>
  )
}

export default InternetLicensesPage
